'use strict';
var parent = require('../../es/object/group-by');

module.exports = parent;
